<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Admin' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>提现列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">提现类型：</el-text>
			<el-col :span="4">
				<el-radio disabled v-model="subData.withdrawType" :label="1">佣金</el-radio>
				<el-radio disabled v-model="subData.withdrawType" :label="2">邮票</el-radio>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">提现金额：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入提现金额" disabled style="width:400px;" v-model="subData.withdrawMoney"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">提现日期：</el-text>
			<el-col :span="4">
				<el-date-picker v-model="subData.addDate" disabled type="date" placeholder="选择日期"></el-date-picker>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">审核结果：</el-text>
			<el-col :span="4">
				<el-radio v-model="jsonData.state" :label="3">通过</el-radio>
				<el-radio v-model="jsonData.state" :label="4">失败</el-radio>
			</el-col>
		</el-row>
		<el-row class="form-row" v-if="jsonData.state==3">
			<el-text style="width:100px; text-align: right;">到账金额：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入到账金额" style="width:400px;" v-model="jsonData.realMoney"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">备注：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入备注" style="width:400px;" v-model="jsonData.remark"></el-input>
			</el-col>
		</el-row>

      <el-row class="bt" style="padding:15px 0; padding-left: 100px;">
        <el-button type="primary" @click="submitEvent">确定</el-button>
        <el-button plain type="primary" @click="backEvent">返回</el-button>
      </el-row>
    </el-card>
  </div>
</template>

  
<script>

export default {
  data() {
    return {
      id: this.$route.query.id?this.$route.query.id:0,
      subData:{
		userId : '',
		withdrawType : '',
		withdrawMoney : '',
		addDate : '',
		complateDate : '',
		state : '',
		remark : '',

      },
	  jsonData:{
		id: '',
		state : '',
		realMoney : '',
		remark : '',
	  }
    }
  },
  mounted:function(){
    if(this.id>0){
      this.getData()
    }
  },
  methods: {
    backEvent(){
        this.$router.go(-1)
    },
    getData(){
      var ths = this
      ths.$get('/Users/queryWithdrawById?id='+ths.id)
      .then(function (res) { 
          if(res.success){
            ths.subData = res.data
			ths.jsonData.id = res.data.id
          }
      })
      .catch(function (err) {
        console.log(err)
      })    
    },
    submitEvent() {
      const ths = this;
	
      ths.$post('/Users/withdrawApply?', ths.jsonData)
        .then(function (res) { 
            alert(res.msg)
            if(res.success){
              ths.$router.push("/Admin/WithdrawLogsList")
            }
        })
        .catch(function (err) {
          console.log(err)
        })      
      },
   }
}

</script>

<style>
.form-row{
  padding:15px 0; 
}
</style>